import { Sitzordnung } from '../../dtos';

export const content = {
  keineVeranstaltungenAenderung: 'Keine Veranstaltungen geändert.',
};

export const sitzordnungLabelByValue: Record<Sitzordnung, string> = {
  FISCHGRAET: 'Fischgrät',
  KINOBESTUHLUNG: 'Kinobestuhlung',
  OHNETISCHE: 'Ohne Tische',
  PARLAMENTARISCH: 'Parlamentarisch',
  RAUMABHAENGIG: 'Raumabhängig',
  RAUMSKIZZE: 'Raumskizze',
  STUHLHALBKREIS: 'Stuhlhalbkreis',
  STUHLKREIS: 'Stuhlkreis',
  TEILNEHMERABHAENGIG: 'Teilnehmerabhängig',
  UFORM: 'U-Form',
  UFORMBREITETISCHE: 'U-Form breite Tische',
  ZWEIERTISCHGRUPPE: '2er-Tischgruppe',
  VIERERTISCHGRUPPE: '4er-Tischgruppe',
  SECHSERTISCHGRUPPE: '6er-Tischgruppe',
  TISCHBLOCK: 'Tischblock',
  PARLAMENTARISCHMITPC: 'Parlamentarisch mit PC',
  ONLINE: 'Online',
};
